import React from 'react';
import {Col, Container, Row, Accordion} from 'react-bootstrap';
import {SanPin} from "../../../app-constants";
import FaqComponents from "../components/common/faq"; 

const faqs = [
    {
        question: "How will custom software development help my business?",
        answer: `<p>Custom software will help your business diversify your customer engagement and ROI channels, meet your users' customized needs, and offer security, integration, flexibility, and scalability. TekRevol helps businesses create user personas, mockups, wireframes, and your application's complete frontend, backend, and server-side architecture.</p>`,
    },
    {
        question: "What technologies and programming languages will you choose?",
        answer: `<p>We employ the programming languages, tools, and frameworks best suited for your custom software project. The choice of technologies and languages will also depend on the platform you choose for your tool. Typically, our developers use Swift, Objective-C, .NET, Java, C++, React, Python, Kotlin, JavaScript, and PHP for iOS and Android applications.</p>`,
    },
    {
        question: "How long does it take to start my software development?",
        answer: `<p>We analyze your project requirements and then inform you about the app estimation results. Once we’re done with all the project requirements, scope, and deliverables, our business analyst will draft a project report document and proposal and share it with you for review.</p>`,
    }, 
    {
        question: " How do you ensure my project information confidentiality and privacy?",
        answer: ` <p>You’ll sign an NDA agreement with us to ensure that all your business details, project information, and ideas are secure with us.</p>`,
    },  
];

function FaqLocation(props) {
    return (
        <div className="faq_loc p-100 tekrevol_dark_bg">
        <Container className="h-100">
            <Row className="h-100">
                <Col
                    xs={12}
                    md={12}
                    lg={12}
                    xl={10}
                    xxl={10}
                    className="m-auto text-center"
                >
                    <div className="example center text-center" data-text="FAQs">
                        <h2>Frequently Asked Questions</h2>
                    </div>
                </Col>
            </Row>
            <Row className="h-100">
                <Col
                    xs={12}
                    md={12}
                    lg={8}
                    xl={7}
                    xxl={7}
                    className="services_faqs"
                >
                    <FaqComponents faqs={faqs} />
                </Col>

                <Col xs={12} md={12} lg={4} xl={4} xxl={4} className="offset-xl-1">
                    <div className="map_loc">
                        {SanPin}
                    </div>
                </Col>
            </Row>
        </Container>
    </div>
    );
}

export default FaqLocation;